import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Step from "./Step/Step";
import Discounts from "./Step/Discounts";
import PaymentForm from "./Step/PaymentForm";
import ConfirmDetails from "./Step/ConfirmDetails";
import PersonalDetails from "./Step/PersonalDetails";
import Congratulations from "./Step/Congratulations";

import style from "./style.module.css";

export default function GiftRegister(props) {

    const userProfile = useSelector((state) => state.storage.data);
    const navigate = useNavigate();

    useEffect(() => {
        if (get(userProfile, 'id', null) !== null) {
            navigate('/home');
        }
    }, [userProfile, navigate])

    const [step, setStep] = useState("PersonalDetails");
    const [personalDetails, setPersonalDetails] = useState({});
    const [planId, setPlanId] = useState();
    const [planType, setPlanType] = useState();
    const [couponId, setCouponId] = useState(null);
    const [paymentIntentDetails, setPaymentIntentDetails] = useState({}); 
    const [autoRenewal, setAutorenewal] = useState(1);
    const [total, setTotal] = useState("0");
    const [originalTotal, setOriginalTotal] = useState("0");
    const totalStep = planType !== 3 && planType !== undefined ? "06" : "04"; // 3 => Free Membership

    // const goBackStep = (backStep) => {
    //     setStep(backStep);
    // }

    return (
        <div className={style.register}>
            {
                step === "PersonalDetails" && (
                    <Step 
                        currentStep="01" 
                        back={false} 
                        totalStep={totalStep} 
                        image={props.step_one_bg_image} 
                        title={props.step_one_title} 
                        text={props.step_one_description}
                    >
                        <PersonalDetails
                            nextStep={setStep}
                            personalDetails={personalDetails}
                            setPersonalDetails={setPersonalDetails}
                            showPlanList={props.show_plan_list}
                            setPlanId={setPlanId}
                            setPlanType={setPlanType}
                        />
                    </Step>
                )
            }
            {
                step === "ConfirmDetails" && (
                    <Step 
                        currentStep="03"
                        back={false}
                        totalStep={totalStep}
                        image={props.step_three_bg_image}
                        title={props.step_three_title}
                        text={props.step_three_description}
                    >
                        <ConfirmDetails
                            personalDetails={personalDetails}
                            setPersonalDetails={setPersonalDetails}
                            nextStep={setStep}
                            planType={planType}
                            planId={planId}
                        />
                    </Step>
                )
            }
            {
                step === "Discounts" && (
                    <Step 
                        currentStep="04" 
                        back={false} 
                        totalStep={totalStep} 
                        image={props.step_four_bg_image} 
                        title={props.step_four_title} 
                        text={props.step_four_description}
                    >
                        <Discounts
                            personalDetails={personalDetails}
                            setPaymentIntentDetails={setPaymentIntentDetails}
                            nextStep={setStep}
                            planId={planId}
                            setTotal={setTotal}
                            total={total}
                            setOriginalTotal={setOriginalTotal}
                            originalTotal={originalTotal}
                            setCouponId={setCouponId}
                            setAutorenewal={setAutorenewal}
                        />
                    </Step>
                )
            }
                        {
                step === "PaymentForm" && (
                    <Step 
                        currentStep="05" 
                        back={false} 
                        totalStep={totalStep} 
                        image={props.step_five_bg_image} 
                        title={props.step_five_title} 
                        text={props.step_five_description}
                    >
                        <PaymentForm
                            paymentIntentDetails={paymentIntentDetails}
                            personalDetails={personalDetails}
                            planId={planId}
                            planType={planType}
                            total={total}
                            couponId={couponId}
                            nextStep={setStep}
                            autoRenewal={autoRenewal}
                        />
                    </Step>
                )
            }
            {
                step === "Congratulations" && (
                    <Step 
                        currentStep={planType !== 3 && planType !== undefined ? "06" : "04"}
                        back={false} 
                        totalStep={planType !== 3 && planType !== undefined ? "06" : "04"}
                        image={props.step_six_bg_image} 
                        title={props.step_six_title} 
                        text={props.step_six_description}
                        stepName="congratulations"
                    >
                        <Congratulations
                            nextStep={false}
                        />
                    </Step>
                )
            }
        </div>
    )
}